/* V59.62 — mobile search-results navigation. */
(function () {
  function goBackOrHome(button) {
    var fallback = button.getAttribute('data-mn-search-fallback') || '/';
    var canUseReferrer = false;

    if (document.referrer) {
      try {
        canUseReferrer = new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        canUseReferrer = false;
      }
    }

    if (canUseReferrer && window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.assign(fallback);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mn-search-results-back]');
    if (!button) return;
    event.preventDefault();
    goBackOrHome(button);
  });
})();
